const pattern = /[^.]+(?=\.)/g;

export default function takeFirstParagraph(subject?: string) {
  if (!subject) return "";
  pattern.lastIndex = 0;
  const paragraph = pattern.exec(subject)?.at(0);
  return !paragraph ? subject : `${paragraph}.`;
}
